import script from "./QuestionQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionQuery.vue?vue&type=script&setup=true&lang=js"

import "./QuestionQuery.vue?vue&type=style&index=0&id=69df47b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69df47b4"]])

export default __exports__